import {
  useCompositeItem
} from "./WFK3YK7D.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "./NQJBHION.js";
import {
  __objRest,
  __spreadValues
} from "./PNRLI7OV.js";

// src/toolbar/toolbar-item.ts
var useToolbarItem = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useCompositeItem(__spreadValues({ store }, props));
    return props;
  }
);
var ToolbarItem = createMemoComponent((props) => {
  const htmlProps = useToolbarItem(props);
  return createElement("button", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  ToolbarItem.displayName = "ToolbarItem";
}

export {
  useToolbarItem,
  ToolbarItem
};
